import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { PortalFeatureFlags } from '../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../services/featureFlags/useFeatureFlagValue';
import PageLayout from '../../ui/Layout';
import PaperContainer from '../../ui/Layout/PaperContainer';

type PortalFeatureFlagName = keyof typeof PortalFeatureFlags;

const PortalFeatureFlagRow = ({ name }: { name: PortalFeatureFlagName }): React.ReactElement => {
  const definition = PortalFeatureFlags[name];
  const value = useFeatureFlagValue(definition, false);

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>{definition.key}</TableCell>
      <TableCell>{String(value)}</TableCell>
    </TableRow>
  );
};

export const FeatureFlagExample = (): React.ReactElement => {
  const orgId = useAppSelector((state) => state.currentApp.OrgId);

  return (
    <PageLayout title="Feature flag example" documentTitle="Feature flag example">
      <PaperContainer>
        <Typography>{`The current orgId is ${orgId ?? 'unknown'}.`}</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Key</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(Object.keys(PortalFeatureFlags) as PortalFeatureFlagName[]).map((name) => (
              <PortalFeatureFlagRow key={name} name={name} />
            ))}
          </TableBody>
        </Table>
      </PaperContainer>
    </PageLayout>
  );
};

export default FeatureFlagExample;
